import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["metaId", "text", "className", "favBtn"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import { useAddFavoriteMutation, useAuthUserWithFavoritesQuery, useDeleteFavoriteMutation, useNotification } from "@/hooks";
import styles from "@/styles/Button.module.scss";
import classnames from "classnames";
import { useCallback, useEffect, useState } from "react";

var IconFav = function IconFav(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      clipRule: "evenodd",
      fill: "none",
      stroke: "#AAA",
      strokeWidth: "1.24",
      d: "m12.6 7.3 5.9.8-4.3 4.2 1.1 5.9-5.3-2.9-5.3 2.8 1.1-5.8-4.3-4.2 5.9-.8L10 1.8l2.6 5.5z"
    })
  }));
};

IconFav.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  xmlSpace: "preserve"
};
import Button from "./Button";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function FavoriteButton(props) {
  var metaId = props.metaId,
      text = props.text,
      className = props.className,
      favBtn = props.favBtn,
      buttonProps = _objectWithoutProperties(props, _excluded);

  var _useNotification = useNotification(),
      showNotification = _useNotification.showNotification;

  var _useState = useState(false),
      favoriteOn = _useState[0],
      setFavoriteOn = _useState[1];

  var _useAddFavoriteMutati = useAddFavoriteMutation({
    onCompleted: function onCompleted(_ref) {
      var addFavorite = _ref.addFavorite;

      if (addFavorite.result) {
        showNotification("お気に入りに登録しました");
        setFavoriteOn(true);
      }
    },
    update: function update(cache) {
      cache.evict({
        fieldName: "favoritesByContentType"
      });
      cache.gc();
    }
  }),
      _useAddFavoriteMutati2 = _slicedToArray(_useAddFavoriteMutati, 1),
      addFavorite = _useAddFavoriteMutati2[0];

  var _useDeleteFavoriteMut = useDeleteFavoriteMutation({
    onCompleted: function onCompleted(_ref2) {
      var deleteFavorite = _ref2.deleteFavorite;

      if (deleteFavorite.result) {
        showNotification("お気に入りから削除しました");
        setFavoriteOn(false);
      }
    },
    update: function update(cache) {
      cache.evict({
        fieldName: "favoritesByContentType"
      });
      cache.gc();
    }
  }),
      _useDeleteFavoriteMut2 = _slicedToArray(_useDeleteFavoriteMut, 1),
      deleteFavorite = _useDeleteFavoriteMut2[0];

  var _useAuthUserWithFavor = useAuthUserWithFavoritesQuery({
    fetchPolicy: "cache-first"
  }),
      data = _useAuthUserWithFavor.data;

  var user = data === null || data === void 0 ? void 0 : data.user;
  var favorites = data === null || data === void 0 ? void 0 : data.favorites;
  var handleClick = useCallback(function (e) {
    e.preventDefault();

    if (favoriteOn) {
      deleteFavorite({
        variables: {
          id: parseInt(metaId, 10)
        }
      });
    } else {
      addFavorite({
        variables: {
          id: parseInt(metaId, 10)
        }
      });
    }
  }, [favoriteOn]);
  useEffect(function () {
    var mounted = true;

    if (user) {
      var fav = !!favorites.metas.find(function (meta) {
        return (meta === null || meta === void 0 ? void 0 : meta.id) === metaId;
      });

      if (mounted) {
        setFavoriteOn(fav);
      }
    }

    return function () {
      mounted = false;
    };
  }, [user, favorites]);
  if (!user) return null;
  return /*#__PURE__*/_jsxs(Button, _objectSpread(_objectSpread({
    title: "\u304A\u6C17\u306B\u5165\u308A"
  }, buttonProps), {}, {
    favBtn: true,
    withIcon: true,
    favBtnWithLabel: !!text,
    className: className,
    onClick: handleClick,
    children: [/*#__PURE__*/_jsx("span", {
      className: classnames(styles.icon, _defineProperty({}, styles.favoriteOn, favoriteOn)),
      children: /*#__PURE__*/_jsx(IconFav, {})
    }), text && /*#__PURE__*/_jsx("span", {
      className: styles.text,
      children: text
    })]
  }));
}